import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import MAdapter from "./MAdapter";
import { isHTTPUrl } from "../utils/utils";

var QQMPAdapter = /*#__PURE__*/function (_MAdapter) {
  _inherits(QQMPAdapter, _MAdapter);

  var _super = _createSuper(QQMPAdapter);

  function QQMPAdapter() {
    var _this;

    _classCallCheck(this, QQMPAdapter);

    return _this = _super.call(this, ["https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js", "https://s1.zhuanstatic.com/common/zzwa/static/js/zzwasdk-v1.4.35.js"], function () {
      _this.zzwa = window.zzwa;
      _this.mqq = window.qq.miniProgram;
      _this.__sdk = _this.mqq;
      if (_this.zzwa.init) _this.zzwa.init();
    });
  }

  _createClass(QQMPAdapter, [{
    key: "login",
    value: function login() {
      var _this$zzwa;

      (_this$zzwa = this.zzwa).login.apply(_this$zzwa, arguments);
    }
  }, {
    key: "skipToUrl",
    value: function skipToUrl(obj) {
      var targetUrl = obj.targetUrl;
      if (!targetUrl) return;

      if (isHTTPUrl(targetUrl)) {
        _get(_getPrototypeOf(QQMPAdapter.prototype), "skipToUrl", this).call(this, obj);
      } else {
        this.mqq.navigateTo({
          url: targetUrl
        });
      }
    }
  }]);

  return QQMPAdapter;
}(MAdapter);

export { QQMPAdapter as default };